'use client'

import { useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { SEARCH_PARAMS } from '@/constants'

type TCancelSubscriptionSourceListenerProps = {
	onSourceChange: (source: string | undefined) => void
}

export const CancelSubscriptionSourceListener = ({
	onSourceChange,
}: TCancelSubscriptionSourceListenerProps) => {
	const source =
		useSearchParams().get(SEARCH_PARAMS.cancelSubscription.sourceKey) ??
		undefined

	useEffect(() => {
		onSourceChange(source)
	}, [source, onSourceChange])

	return null
}
